export function Layout(props) {
    return props.children;
}
